import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-nature',
  templateUrl: './magic-uses-nature.component.html',
  styleUrls: ['./magic-uses-nature.component.css']
})
export class MagicUsesNatureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
